import { FormattedNumber } from '@sm/intl';

const CURRENCIES_TO_INCLUDE_CODE = ['CAD', 'AUD'];

const formattedCurrency = (cost, currencyCode) => {
  const currency = FormattedNumber({
    key: 'pricing_header',
    value: cost,
    formatStyle: 'currency',
    currency: currencyCode,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0
  });

  // FIXME: Due to Smartling, we're always returning en-US for Enlgish locales.
  // Browser locale does not always match actual language+location.
  // This is a workaround until we have a better way to determine correct locale.
  const narrowCurrency = currency.substring(currency.indexOf('$'));

  if (CURRENCIES_TO_INCLUDE_CODE.includes(currencyCode)) {
    return `${narrowCurrency} ${currencyCode}`;
  }
  return narrowCurrency;
};

export default formattedCurrency;
